/* =========================================================================== *\
 __      __.__     ___________           .__    ____ ________  ________.________
/  \    /  \__| ___\__    ___/___   ____ |  |__/_   /   __   \/   __   \   ____/
\   \/\/   /  |/    \|    |_/ __ \_/ ___\|  |  \|   \____    /\____    /____  \ 
 \        /|  |   |  \    |\  ___/\  \___|   Y  \   |  /    /    /    //       \
  \__/\  / |__|___|  /____| \___  >\___  >___|  /___| /____/    /____//______  /
       \/          \/           \/     \/     \/                             \/ 
\* =========================================================================== */

import React, { useEffect, useState, useRef } from "react";
import { useParams } from "react-router-dom";
import PropTypes from "prop-types";

// @mui material components
import Icon from "@mui/material/Icon";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import TableHead from "@mui/material/TableHead";
import Grid from "@mui/material/Grid";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import Avatar from "@mui/material/Avatar";
import Paper from "@mui/material/Paper";
import TableContainer from "@mui/material/TableContainer";
import InputAdornment from "@mui/material/InputAdornment";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";

// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDSnackbar from "components/MDSnackbar";
import MDInput from "components/MDInput";
import MDSelect from "components/MDSelect";
import MDTypography from "components/MDTypography";
import TableHeader from "components/Table/TableHeader";
import MDDatePicker from "components/MDDatePicker";

// Material Dashboard 2 PRO React examples
import { useTranslation } from "react-i18next";
import { APP_STATE } from "services/Define";
import { FetchData } from "services/Request";
import { useSelector } from "react-redux";
import * as Func from "services/Function";

const initAttr = {
  id: "",
  list_id: "",
  production_id: "",
  product_id: "",
  product_sku: "",
  product_name: "",
  product_image: "",
  price: "",
  quantity: "",
  amount: "",
  unit_id: "",
  warehouse_id: "",
  zone_id: "",
  unit_name: "",
  lot: "",
  is_expire: "N",
  date_expire: Func.dateNow(),
  created_at: "",
  updated_at: "",
};

const initFind = {
  search: "",
  order_by: "tb.id",
  order_sort: "asc",
  page: 1,
  perPage: 10,
  pageTotal: 0,
};

const initParent = {
  id: "",
  code: "",
  remark: "",
  type_id: "",
  supplier_id: "",
  pr_id: "0",
  pr_type: "",
  pr_date: "",
  pr_remark: "",
  pr_user: "",
  vat_type: "NO",
  status: "edit",
  print_url: "",
  created_at: "",
  updated_at: "",
};

function ProductionFinishList() {
  const mod = "production_finish_list";
  const app = useSelector((state) => state[APP_STATE]);
  const { t, i18n } = useTranslation();
  const { id } = useParams();
  const [record, setRecord] = useState([]);
  const [attr, setAttr] = useState(initAttr);
  const [find, setFind] = useState(initFind);
  const [notify, setNotify] = useState(null);
  const [confirm, setConfirm] = useState(false);
  const [loading, setLoading] = useState(true);
  const [order, setOrder] = useState(initFind.order_sort);
  const [orderBy, setOrderBy] = useState(initFind.order_by);
  const [modalAdd, setModalAdd] = useState(false);
  const [modalEdit, setModalEdit] = useState(false);
  const [modalDel, setModalDel] = useState(false);
  const [modalProduct, setModalProduct] = useState(false);
  const [modalPR, setModalPR] = useState(false);
  const [cboProduct, setCboProduct] = useState([]);
  const [cboPR, setCboPR] = useState([]);
  const [cboWarehouse, setCboWarehouse] = useState([]);
  const [cboZone, setCboZone] = useState([]);
  const [parent, setParent] = useState(initParent);

  const txtSearchProduct = useRef(null);
  const txtPrice = useRef(null);
  const txtQuantity = useRef(null);

  const initHeader = [
    { id: "edit", label: "", align: "center", sort: false },
    { id: "tb.id", label: t(`attr.id`), align: "center" },
    { id: "pd.image_id", label: t(`attr.image`), align: "center" },
    { id: "tb.product_id", label: "สินค้า", align: "left" },
    { id: "tb.quantity", label: "จำนวน", align: "right" },
    { id: "tb.unit_id", label: "หน่วย", align: "left" },
    { id: "tb.warehouse_id", label: "คลัง", align: "left" },
    { id: "tb.zone_id", label: "โซน", align: "left" },
    { id: "tb.lot", label: "LOT", align: "left" },
    { id: "delete", label: "", align: "center", sort: false },
  ];

  const showNotify = (msg, color) => {
    setNotify(
      <MDSnackbar
        color={color}
        icon="notifications"
        title={t(`app.name`)}
        content={msg}
        dateTime={Func.dateTimeDisplay()}
        open={Boolean(true)}
        close={() => setNotify(!notify)}
      />
    );

    setTimeout(function () {
      setNotify(null);
    }, 3000);
  };

  const view = (data) => {
    setFind(data);
    setLoading(true);
    setRecord([]);

    FetchData("POST", `/${mod}`, app.token, {
      lang: app.lang,
      search: data.search,
      page: data.page,
      per_page: data.perPage,
      orderby: data.order_by,
      ordersort: data.order_sort,
      ref_id: id,
    }).then((result) => {
      if (result.status === "ok") {
        setRecord(result.data);
        setParent(result.parent);
      }
      setLoading(false);
    });
  };

  const open = (item) => {
    setAttr({
      ...initAttr,
      id: item.id,
      price: item.price,
      quantity: item.quantity,
      amount: item.price * item.quantity,
    });
    setModalEdit(true);
    setConfirm(false);

    setTimeout(function () {
      txtPrice.current.select();
    }, 500);
  };

  const searchProduct = () => {
    setAttr(initAttr);

    FetchData("OPTIONS", `/${mod}/product`, app.token, {
      search: txtSearchProduct.current.value,
    }).then((result) => {
      if (result.status === "ok") {
        setCboProduct(result.data);
        setModalProduct(true);
        setConfirm(false);

        setTimeout(function () {
          txtSearchProduct.current.focus();
        }, 500);
      } else {
        Func.exitApp();
      }
    });
  };

  const searchPO = () => {
    setAttr(initAttr);

    FetchData("OPTIONS", `/${mod}/po`, app.token, {
      id: id,
    }).then((result) => {
      if (result.status === "ok") {
        setCboPR(result.data);
        setModalPR(true);
        setConfirm(false);
      } else {
        Func.exitApp();
      }
    });
  };

  const productSelect = (row) => {
    setAttr({
      ...attr,
      list_id: "0",
      product_id: row.id,
      product_sku: row.sku,
      product_name: row.name,
      product_image: row.image,
      unit_id: row.unit_id,
      unit_name: row.unit_name,
    });
    setModalAdd(true);
    setModalProduct(false);
    setConfirm(false);

    setTimeout(function () {
      txtQuantity.current.focus();
    }, 500);
  };

  const prSelect = (row) => {
    setAttr({
      ...attr,
      list_id: row.id,
      product_id: row.product_id,
      product_sku: row.sku,
      product_name: row.name,
      product_image: row.image,
      quantity: row.quantity,
      price: row.price,
      unit_id: row.unit_id,
      unit_name: row.unit_name,
    });
    setModalAdd(true);
    setModalPR(false);
    setConfirm(false);

    setTimeout(function () {
      txtQuantity.current.select();
    }, 500);
  };

  const addConfirm = () => {
    if (!Func.verifyLength(attr.product_id, 1)) return;
    if (!Func.verifyLength(attr.unit_id, 1)) return;

    setConfirm(true);
  };

  const add = () => {
    setLoading(true);
    setModalAdd(false);

    FetchData("PUT", `/${mod}`, app.token, {
      production_id: id,
      list_id: attr.list_id,
      product_id: attr.product_id,
      quantity: attr.quantity,
      unit_id: attr.unit_id,
      warehouse_id: attr.warehouse_id,
      zone_id: attr.zone_id,
      lot: attr.lot,
      is_expire: attr.is_expire,
      date_expire: attr.date_expire,
    }).then((result) => {
      setLoading(false);

      if (result.status === "ok") {
        view(find);
        showNotify(t(`alert.addcomplete`), "success");
      } else {
        setModalAdd(true);
        showNotify(t(`alert.saveerror`), "error");
      }
    });
  };

  const editConfirm = () => {
    if (!Func.verifyLength(attr.quantity, 1)) return;

    setConfirm(true);
  };

  const edit = () => {
    setLoading(true);
    setModalEdit(false);

    FetchData("PATCH", `/${mod}/${attr.id}`, app.token, {
      quantity: attr.quantity,
    }).then((result) => {
      setLoading(false);

      if (result.status === "ok") {
        view(find);
        showNotify(t(`alert.editcomplete`), "success");
      } else {
        setModalEdit(true);
        showNotify(t(`alert.saveerror`), "error");
      }
    });
  };

  const del = () => {
    setLoading(true);
    setModalDel(false);

    FetchData("DELETE", `/${mod}/${attr.id}`, app.token, {}).then((result) => {
      setLoading(false);

      if (result.status === "ok") {
        view(find);
        showNotify(t(`alert.deletecomplete`), "success");
      } else {
        showNotify(t(`alert.deleteerror`), "error");
      }
    });
  };

  const renderLoading = () => {
    return (
      <Backdrop sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }} open={loading}>
        <CircularProgress color="inherit" />
      </Backdrop>
    );
  };

  const handleSort = (e, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);

    view({ ...find, order_by: property, order_sort: isAsc ? "desc" : "asc" });
  };

  const init = () => {
    FetchData("GET", `/${mod}`, app.token, {
      ref_id: id,
    }).then((result) => {
      if (result.status === "ok") {
        setCboWarehouse(result.warehouse);
        setAttr(initAttr);
        view(find);
      } else {
        Func.exitApp();
      }
    });
  };

  const imageDisplay = (item) => {
    return <Avatar alt={item.name} src={item.image} variant="rounded" />;
  };

  const btnEdit = (item) => {
    if (parent.status !== "edit") return null;

    return (
      <MDButton variant="text" color="success" size="small" iconOnly onClick={() => open(item)}>
        <Icon>border_color</Icon> {t(`element.edit`)}
      </MDButton>
    );
  };

  const btnDel = (item) => {
    if (parent.status !== "edit") return null;

    return (
      <MDButton
        variant="text"
        color="error"
        size="small"
        iconOnly
        onClick={() => {
          setConfirm(false);
          setAttr(item);
          setModalDel(true);
        }}
      >
        <Icon>delete</Icon>
      </MDButton>
    );
  };

  const renderList = () => {
    return (
      <MDBox mb={3}>
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <MDBox p={2}>
              <MDTypography variant="h5">{t(`element.order`)}</MDTypography>
            </MDBox>
          </Grid>
          {parent.status !== "edit" ? null : (
            <Grid item xs={6}>
              <MDBox display="flex" justifyContent="flex-end" gap={1} p={2}>
                <MDButton variant="outlined" color="success" onClick={() => searchPO()}>
                  <Icon>add_circle_outline</Icon>&nbsp;เพิ่มจากใบควบคุม
                </MDButton>
              </MDBox>
            </Grid>
          )}
          <Grid item xs={12}>
            <TableContainer sx={{ boxShadow: 0 }}>
              <Table aria-label="simple table">
                <TableHeader
                  order={order}
                  orderBy={orderBy}
                  onRequestSort={handleSort}
                  data={initHeader}
                />
                <TableBody>
                  {record.map((row) => (
                    <TableRow key={row.id}>
                      <TableCell align="center" width="10">
                        {btnEdit(row)}
                      </TableCell>
                      <TableCell align="center" width="100">
                        {row.no}
                      </TableCell>
                      <TableCell width="40">{imageDisplay(row)}</TableCell>
                      <TableCell align="left">{row.product_name}</TableCell>
                      <TableCell align="right" width="150">
                        {Func.numberDisplay(row.quantity)}
                      </TableCell>
                      <TableCell>{row.unit_name}</TableCell>
                      <TableCell>{row.warehouse_name}</TableCell>
                      <TableCell>{row.zone_name}</TableCell>
                      <TableCell>{row.lot}</TableCell>
                      <TableCell align="center" width="10">
                        {btnDel(row)}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Grid>
        </Grid>
      </MDBox>
    );
  };

  const renderInfo = () => {
    return (
      <Grid container spacing={5}>
        <Grid item xs={6} lg={4}>
          <Paper sx={{ p: 2 }} variant="outlined">
            {attr.product_image === "" ? null : (
              <MDBox
                component="img"
                src={attr.product_image}
                alt={attr.product_name}
                width="100%"
                height="100%"
                onClick={() => {
                  setModalAdd(false);
                  setModalEdit(false);
                  setModalPR(true);
                }}
                sx={{ cursor: "pointer" }}
              />
            )}
          </Paper>
        </Grid>
        <Grid item xs={6} lg={4}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <MDInput
                label="สินค้า"
                value={attr.product_name}
                variant="standard"
                fullWidth
                inputProps={{
                  autoComplete: "off",
                  readOnly: true,
                }}
              />
            </Grid>
            <Grid item xs={12}>
              <MDInput
                label="จำนวน *"
                onChange={(e) => setAttr({ ...attr, quantity: e.target.value })}
                value={attr.quantity}
                variant="standard"
                type="number"
                fullWidth
                InputProps={{
                  inputRef: txtQuantity,
                  autoComplete: "off",
                  endAdornment: (
                    <InputAdornment position="start">
                      <span>{attr.unit_name}</span>
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={6} lg={4}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <MDSelect
                label="คลัง"
                labelDefault={t(`element.please_select`)}
                data={cboWarehouse}
                value={attr.warehouse_id}
                onChange={(e) => {
                  setAttr({ ...attr, warehouse_id: e.target.value });

                  cboWarehouse.forEach((item, i) => {
                    if (item.id === e.target.value) {
                      setCboZone(item.zone);
                    }
                  });
                }}
              />
            </Grid>
            <Grid item xs={12}>
              <MDSelect
                label="โซน"
                labelDefault={t(`element.please_select`)}
                data={cboZone}
                value={attr.zone_id}
                onChange={(e) => setAttr({ ...attr, zone_id: e.target.value })}
              />
            </Grid>
            <Grid item xs={12}>
              <MDInput
                label="LOT"
                onChange={(e) => setAttr({ ...attr, lot: e.target.value })}
                value={attr.lot}
                variant="standard"
                fullWidth
                InputProps={{
                  autoComplete: "off",
                }}
              />
            </Grid>
            <Grid item xs={12}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={attr.is_expire === "Y"}
                    onChange={(e) => setAttr({ ...attr, is_expire: e.target.checked ? "Y" : "N" })}
                    inputProps={{
                      "aria-label": "enable",
                    }}
                  />
                }
                label="เพิ่มวันหมดอายุ"
              />
            </Grid>
            {attr.is_expire === "Y" ? (
              <Grid item xs={12}>
                <MDDatePicker
                  onChange={([date]) => {
                    setAttr({ ...attr, date_expire: Func.dateFormat(date) });
                  }}
                  value={new Date(attr.date_expire)}
                  input={{
                    label: "วันหมดอายุ",
                    variant: "standard",
                    fullWidth: true,
                  }}
                />
              </Grid>
            ) : null}
          </Grid>
        </Grid>
      </Grid>
    );
  };

  const renderPR = () => {
    return (
      <Dialog open={modalPR} maxWidth="md" keepMounted aria-describedby="dialog-pr" fullWidth>
        <DialogTitle>
          <Grid container>
            <Grid item xs={8}>
              รายการผลิต
            </Grid>
            <Grid item xs={4}>
              <IconButton
                aria-label="close"
                onClick={() => setModalPR(false)}
                sx={{
                  position: "absolute",
                  right: 8,
                  top: 15,
                  color: (theme) => theme.palette.grey[500],
                }}
              >
                <Icon>close</Icon>
              </IconButton>
            </Grid>
          </Grid>
        </DialogTitle>
        <DialogContent dividers sx={{ minHeight: 500 }}>
          <MDBox>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Table aria-label="pr table" size="small">
                  <TableHead>
                    <TableRow>
                      <TableCell align="center">รูป</TableCell>
                      <TableCell>SKU</TableCell>
                      <TableCell>สินค้า</TableCell>
                      <TableCell align="right">จำนวน</TableCell>
                      <TableCell align="right">ผลิตเสร็จ</TableCell>
                      <TableCell align="right">รอผลิต</TableCell>
                      <TableCell>หน่วย</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {cboPR.map((row) => (
                      <TableRow
                        hover
                        key={row.id}
                        onClick={() => prSelect(row)}
                        sx={{ cursor: "pointer" }}
                      >
                        <TableCell width="40">{imageDisplay(row)}</TableCell>
                        <TableCell>{row.sku}</TableCell>
                        <TableCell>{row.name}</TableCell>
                        <TableCell align="right">{Func.numberDisplay(row.quantity)}</TableCell>
                        <TableCell align="right">
                          {Func.numberDisplay(row.quantity_receive)}
                        </TableCell>
                        <TableCell align="right">
                          {Func.numberDisplay(row.quantity_balance)}
                        </TableCell>
                        <TableCell>{row.unit_name}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </Grid>
            </Grid>
          </MDBox>
        </DialogContent>
      </Dialog>
    );
  };

  const renderProduct = () => {
    return (
      <Dialog
        open={modalProduct}
        maxWidth="sm"
        keepMounted
        aria-describedby="dialog-product"
        fullWidth
      >
        <DialogTitle>
          <Grid container>
            <Grid item xs={8}>
              <MDBox
                noValidate
                component="form"
                role="form"
                onSubmit={(e) => {
                  e.preventDefault();
                  searchProduct();
                }}
              >
                <MDInput
                  name="searchform"
                  fullWidth
                  InputProps={{
                    inputRef: txtSearchProduct,
                    startAdornment: (
                      <InputAdornment position="start">
                        <span>ค้นหาสินค้า :</span>
                      </InputAdornment>
                    ),
                    autoComplete: "off",
                  }}
                />
              </MDBox>
            </Grid>
            <Grid item xs={4}>
              <IconButton
                aria-label="close"
                onClick={() => setModalProduct(false)}
                sx={{
                  position: "absolute",
                  right: 8,
                  top: 15,
                  color: (theme) => theme.palette.grey[500],
                }}
              >
                <Icon>close</Icon>
              </IconButton>
            </Grid>
          </Grid>
        </DialogTitle>
        <DialogContent dividers sx={{ minHeight: 500 }}>
          <MDBox>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Table aria-label="product table" size="small">
                  <TableBody>
                    {cboProduct.map((row) => (
                      <TableRow
                        hover
                        key={row.id}
                        onClick={() => productSelect(row)}
                        sx={{ cursor: "pointer" }}
                      >
                        <TableCell width="40">{imageDisplay(row)}</TableCell>
                        <TableCell>{row.name}</TableCell>
                        <TableCell align="right">{Func.numberDisplay(row.price)}</TableCell>
                        <TableCell>บาท</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </Grid>
            </Grid>
          </MDBox>
        </DialogContent>
      </Dialog>
    );
  };

  const renderAdd = () => {
    return (
      <Dialog open={modalAdd} maxWidth="md" keepMounted aria-describedby="dialog-add" fullWidth>
        <DialogTitle>
          {t(`element.add`)}
          <IconButton
            aria-label="close"
            onClick={() => setModalAdd(false)}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <Icon>close</Icon>
          </IconButton>
        </DialogTitle>
        <DialogContent dividers>
          <MDBox p={3}>{renderInfo()}</MDBox>
        </DialogContent>
        <DialogActions>
          {confirm ? (
            <Grid container>
              <Grid item xs={6}>
                <MDButton variant="text" color="error" onClick={() => setConfirm(false)}>
                  <Icon>cancel</Icon>&nbsp;{t(`element.cancel`)}
                </MDButton>
              </Grid>
              <Grid item xs={6} display="flex" justifyContent="flex-end">
                <MDButton variant="outlined" color="success" onClick={add}>
                  <Icon>save</Icon>&nbsp;{t(`element.saveconfirm`)}
                </MDButton>
              </Grid>
            </Grid>
          ) : (
            <MDButton variant="text" color="info" onClick={addConfirm}>
              <Icon>save</Icon>&nbsp;{t(`element.save`)}
            </MDButton>
          )}
        </DialogActions>
      </Dialog>
    );
  };

  const renderEdit = () => {
    return (
      <Dialog open={modalEdit} maxWidth="xs" keepMounted aria-describedby="dialog-edit" fullWidth>
        <DialogTitle>
          {t(`element.edit`)} #{attr.id}
          <IconButton
            aria-label="close"
            onClick={() => setModalEdit(false)}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <Icon>close</Icon>
          </IconButton>
        </DialogTitle>
        <DialogContent dividers>
          <MDBox p={3}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <MDInput
                  label="จำนวน *"
                  onChange={(e) =>
                    setAttr({
                      ...attr,
                      quantity: e.target.value,
                      amount: attr.price * e.target.value,
                    })
                  }
                  value={attr.quantity}
                  variant="standard"
                  type="number"
                  fullWidth
                  InputProps={{
                    autoComplete: "off",
                  }}
                />
              </Grid>
            </Grid>
          </MDBox>
        </DialogContent>
        <DialogActions>
          {confirm ? (
            <Grid container>
              <Grid item xs={6}>
                <MDButton variant="text" color="error" onClick={() => setConfirm(false)}>
                  <Icon>cancel</Icon>&nbsp;{t(`element.cancel`)}
                </MDButton>
              </Grid>
              <Grid item xs={6} display="flex" justifyContent="flex-end">
                <MDButton variant="outlined" color="success" onClick={edit}>
                  <Icon>save</Icon>&nbsp;{t(`element.saveconfirm`)}
                </MDButton>
              </Grid>
            </Grid>
          ) : (
            <MDButton variant="text" color="success" onClick={editConfirm}>
              <Icon>save</Icon>&nbsp;{t(`element.save`)}
            </MDButton>
          )}
        </DialogActions>
      </Dialog>
    );
  };

  const renderDelete = () => {
    return (
      <Dialog
        open={modalDel}
        onClose={() => setModalDel(false)}
        maxWidth="sm"
        keepMounted
        aria-describedby="dialog-delete"
      >
        <DialogTitle>
          {t(`element.delete`)} #{attr.id}
          <IconButton
            aria-label="close"
            onClick={() => setModalDel(false)}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <Icon>close</Icon>
          </IconButton>
        </DialogTitle>
        <DialogContent dividers>
          <DialogContentText p={5}>{t(`alert.confirm_delete_title`)}</DialogContentText>
        </DialogContent>
        <DialogActions>
          {confirm ? (
            <Grid container>
              <Grid item xs={6}>
                <MDButton variant="text" color="error" onClick={() => setModalDel(false)}>
                  <Icon>cancel</Icon>&nbsp;{t(`element.cancel`)}
                </MDButton>
              </Grid>
              <Grid item xs={6} display="flex" justifyContent="flex-end">
                <MDButton variant="gradient" color="error" onClick={del}>
                  <Icon>delete</Icon>&nbsp;{t(`element.deleteconfirm`)}
                </MDButton>
              </Grid>
            </Grid>
          ) : (
            <MDButton variant="text" color="error" onClick={() => setConfirm(true)}>
              <Icon>delete</Icon>&nbsp;{t(`element.delete`)}
            </MDButton>
          )}
        </DialogActions>
      </Dialog>
    );
  };

  useEffect(() => {
    i18n.changeLanguage(app.lang);

    init();
  }, [id]);

  return (
    <div>
      {renderList()}
      {renderAdd()}
      {renderEdit()}
      {renderDelete()}
      {renderPR()}
      {renderLoading()}
      {notify}
    </div>
  );
}

export default ProductionFinishList;
